import { createSelector } from 'reselect';

const selectFulfillmentProviders = (state: any) => state.fulfillmentProviders;


export const selectFulfillmentProvidersCurrentItem = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.current);

export const selectFulfillmentProvidersListItems = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.list);

export const selectFulfillmentProvidersItemById = (itemId: any) =>
    createSelector(selectFulfillmentProvidersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectFulfillmentProvidersQueryItems = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.query);

export const selectFulfillmentProvidersCreatedItem = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.create);

export const selectFulfillmentProvidersUpdatedItem = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.update);

export const selectFulfillmentProvidersReadItem = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.read);

export const selectFulfillmentProvidersDeletedItem = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.delete);

export const selectFulfillmentProvidersSearchedItems = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.search);

export const selectFulfillmentProvidersItemsCount = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.count);

export const selectFulfillmentProvidersItemsFilter = createSelector([selectFulfillmentProviders], (fulfillmentProviders) => fulfillmentProviders.filter);